import { H3 } from '@h3/types';
export namespace FlowCenter {
    /** 流程中心对应类型的枚举 */
    export enum WorkflowLoadType {
        /** 已办 */
        Done = 4,

        /** 我发起的 */
        MyInstance = 3,

        /** 待阅 */
        UnRead = 2,

        /** 待办 */
        UnFinished = 1,

        /** 全部 */
        All = 0,
    }

    /** 流程中心任务类型 */
    export enum WorkflowTaskType {
        /** 待办 */
        Todo = 'todo',

        /** 待阅 */
        ToRead = 'toread',

        /** 我发起的 */
        Apply = 'apply',

        /** 已办 */
        Done = 'done',

        /** 全部 */
        All = 'all',
    }

    /** 流程中心按钮类型 */
    export enum WorkflowActionType {
        /** 详情 */
        Detail = 'detail',

        /** 进入处理 */
        GoHandle = 'goHandle',

        /** 已阅 */
        MarkAsRead = 'markAsRead',

        /** 进入审批 */
        GoApproval = 'goApproval',

        /** 按钮 */
        Button = 'button',
    }

    /** 流程中心操作枚举 */
    export enum WorkflowActions {
        /** 提交和审批同意 */
        SUBMIT = 'SUBMIT',

        /** 审批不同意 */
        REJECT = 'REJECT',

        /** 删除 */
        REMOVE = 'REMOVE',

        /** 已阅 */
        READ = 'READ',

        /** 转交 */
        FORWARD = 'FORWARD',

        /** 作废流程 */
        CANCELINSTANCE = 'CANCELINSTANCE',
    }

    /** 流程中心 全部页签 的标签状态枚举 */
    export enum WorkflowStatusLabel {
        Empty = '',

        /** 我发起的 */
        Mine = 'mine',

        /** 待办 */
        Todo = 'todo',

        /** 已办 */
        Done = 'done',

        /** 待阅 */
        Toread = 'toread',

        /** 已阅 */
        Readed = 'readed',
    }

    /** 流程中心筛选状态值 */
    export enum WorkflowStatusKey {
        /** 全部 */
        All = '0',
        /** 我发起的 */
        Mine = '1',
        /** 待办 */
        Todo = '2',
        /** 已办 */
        Done = '3',
        /** 待阅 */
        Toread = '4',
        /** 已阅 */
        Readed = '5',
        /** 进行中 */
        Working = '6',
        /** 已作废 */
        Canceled = '7',
    }

    /** 流程中心列表字段排序 */
    export enum SortDirection {
        /** 升序 */
        ASC = 0,

        /** 降序 */
        DESC = 1,
    }

    /** 待办中批量操作的弹框类型 */
    export enum BatchModalType {
        Agree = 'agree',
        Disagree = 'disagree',
        Close = 'close',
    }

    /** 审批状态 */
    export enum ApprovalStatus {
        Success = 'success',
        Fail = 'fail',
    }

    /** 审批结果类型 */
    export interface IApprovalResults {
        id: string;
        title: string;
        status: ApprovalStatus;
        message?: string;
    }

    export interface IExtraData {
        /** 排序字段名称 */
        ItemCode: string;
        /** 排序类型 */
        SortDirection: SortDirection;
    }

    /** 筛选数据结构 */
    export interface IFilterData {
        belongApp: H3.FunctionNode.IFunctionNode[];
        belongAppStr: string;
        receiveTime: string[];
        finishTime: string[];
        creator: H3.Org.IOrgInfo[];
        creatorStr: string;
        workflowStatus: string;
        keyWord: string;
    }

    /** 流程中心列表数据结构 */
    export interface IWorkflowFormData {
        AppCode: string;
        Code: string;
        DirtyProperties: string[];
        DisplayName: string;
        EnableDataAcl: boolean;
        IconColorIndex: number;
        IconCss: string;
        IsAppSetting: boolean;
        IsWorkflowModule: boolean;
        IsWorkflowNode: boolean;
        NodeType: number;
        NodeVisible: number;
        ObjectId: string;
        ParentCode: string | null;
        ParentIndex: number;
        ParentObjectId: string | null;
        ParentPropertyName: string | null;
        Removable: boolean;
        Serialized: boolean;
        SortKey: number;
        State: number;
        Url: string;
        Visible: boolean;
        children: IWorkflowCategorys[];
    }

    export interface IWorkflowCategorys {
        AppCode: string;
        ChildMyworkflow: string[];
        DisplayName: string;
        IconCss: string;
        SortKey: number;
        WorkflowCode: string;
        WorkflowVeision: string | null;
    }

    export interface IControlsOptions {
        /** 控件对应字段编码 */
        DataField: string;
        /** 控件类型 */
        ControlKey: H3.Control.FormControlKeys;
        /** 控件显示名称 */
        DisplayName: string;
        /** 控件描述 */
        Description: string;
        /** 控件转换 */
        TransferItems: H3.Control.FormControlKeys;
        /** 隐藏规则 */
        DisplayRule: H3.Control.ControlDesigner.Rule;
        SelectShowMode: H3.Control.SelectShowMode;
        /** 默认选项 */
        DefaultItems: string[];
        /** 默认值 */
        DefaultValue: string;
        /** 颜色开关 */
        ColorSwitch: boolean;
        /** 选项颜色 */
        ItemColors: H3.Control.ColorSelectItem[];
    }

    export interface IColorControls {
        Key: string;
        ParentKey: string;
        Options: IControlsOptions;
        Type: number;
        TabGroupKey: string;
        ChildControls: IColorControls[];
    }

    export interface ISummaryControls {
        controlKey: string;
        label: string;
        value: string;
        colorSwitch: boolean;
        itemColors: H3.Control.ColorSelectItem[];
        controlType?: number;
        entryIds?: string;
    }
}
